import { fetchEntries, getBuilderSearchParams } from "@builder.io/sdk-react";

import { env } from "@/env";
import { createFetchCacheConfig } from "@/libs/cache-config/fetch/createFetchCacheConfig";

import type { BuilderModels } from "../builder.models.types";

import { sanitizeBuilderEntries } from "./sanitizeBuilderContent";

type FetchEntriesParams = Parameters<typeof fetchEntries>;
type FetchEntriesOptions = Omit<FetchEntriesParams[0], "apiKey" | "model"> & {
  model: BuilderModels;
  limit?: number;
  offset?: number;
};

export async function fetchBuilderEntries({ options, limit, offset, locale, ...restParams }: FetchEntriesOptions) {
  const entries = await fetchEntries({
    fetch: fetchWithCache,
    cacheSeconds: 0, // intentionally disable cache
    apiKey: env.builderApiKey,
    options: {
      ...getBuilderSearchParams(options),
      cachebust: true, // intentionally disable cache
      limit,
      offset,
    },
    locale,
    ...(locale && { userAttributes: { locale } }),
    ...restParams,
  });

  return sanitizeBuilderEntries(entries);
}

const fetchWithCache = (input: string, init?: object | undefined) => {
  return fetch(input, {
    ...createFetchCacheConfig({ tags: ["builder-fetch-cache-tag"] }),
    ...init,
  });
};
